import type { IconAsset } from '../Icon.types';

const code = (
  <path
    clipRule='evenodd'
    d='M10.275,0A10.275,10.275,0,1,0,20.55,10.275,10.275,10.275,0,0,0,10.275,0Zm1.182,13.688a2.524,2.524,0,0,1-2.15-1.1s-.511,2.028-.619,2.419A9.377,9.377,0,0,1,7.1,17.89a.117.117,0,0,1-.209-.05,9.878,9.878,0,0,1,.027-3.344c.168-.715,1.132-4.8,1.132-4.8a3.389,3.389,0,0,1-.28-1.393c0-1.3.756-2.278,1.7-2.278a1.178,1.178,0,0,1,1.187,1.321,18.908,18.908,0,0,1-.776,3.123,1.362,1.362,0,0,0,1.389,1.7c1.668,0,2.79-2.142,2.79-4.68,0-1.929-1.3-3.373-3.662-3.373A4.169,4.169,0,0,0,6.058,8.33a2.538,2.538,0,0,0,.581,1.726.427.427,0,0,1,.127.49c-.043.162-.139.552-.18.706a.3.3,0,0,1-.441.221,3.39,3.39,0,0,1-1.8-3.362c0-2.5,2.108-5.5,6.29-5.5a5.261,5.261,0,0,1,5.572,5.042C16.206,11.108,14.286,13.688,11.457,13.688Z'
    fill='currentColor'
    fillRule='evenodd'
  />
);

export const pinterest: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
